exports = module.exports = require("../../node_modules/@vue/cli-service/node_modules/css-loader/lib/css-base.js")(false);
// imports


// module
exports.push([module.id, ".estimatePrice.ant-input-number.ant-input-number-disabled {\n  color: #000;\n}\n", ""]);

// exports
